require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/library/fn/object/keys.js